import { Bolt, FactCheck, Favorite, GroupAdd, VerifiedUser } from '@mui/icons-material';
import { Colors } from 'library';

export interface Feature {
    key: string;
    title: string;
    body: string;
    icon: typeof GroupAdd;
    color: string;
    bg: string;
}

export const FEATURES: Feature[] = [
    {
        key: 'vetted',
        title: 'Vetted Teachers',
        body: 'Every teacher is screened, qualified, and compliant with your state.',
        icon: VerifiedUser,
        color: Colors.secondary,
        bg: Colors.secondarySoft,
    },
    {
        key: 'same-day',
        title: 'Same-Day Coverage',
        body: 'Post a need and get matched with available teachers within a day.',
        icon: Bolt,
        color: Colors.primary,
        bg: Colors.fill,
    },
    {
        key: 'flexible-staffing',
        title: 'Flexible Staffing Options',
        body: 'Coverage for call-offs, vacations, leaves, and more.',
        icon: Favorite,
        color: Colors.accent,
        bg: Colors.accentSoft,
    },
];

export const HOW_STEPS = [
    {
        n: 1,
        title: 'Post Your Jobs',
        body: 'Post substitute needs and reach qualified workers instantly.',
    },
    {
        n: 2,
        title: 'Wait While We Work',
        body: 'Our software carefully matches your requirements with a qualified, compliant teacher.',
    },
    {
        n: 3,
        title: 'Meet Your Match',
        body: 'Once matched, your teacher begins their assignment. Great fit? Request them again.',
    },
];

export const GET_STARTED_CHIPS = [
    { key: 'post', label: 'Post a Need', icon: GroupAdd, color: Colors.secondary },
    { key: 'match', label: 'Get Matched', icon: FactCheck, color: Colors.primary },
    { key: 'covered', label: 'Stay Covered', icon: Bolt, color: Colors.accent },
];
